/** Warm filter for photos on the dark blue hero. */
export const HERO_PHOTO_FILTER =
  'saturate(0.8) sepia(0.14) contrast(1.02) brightness(0.98)'

/**
 * Lighter filter for photos on cream sections: keeps a slight desaturation of
 * the greens, drops most of the warm tone so photos don't melt into the cream.
 */
export const LIGHT_PHOTO_FILTER = 'saturate(0.9) sepia(0.04) contrast(1.01)'
